<template>
  <div class="container">
    <div :class="widthValid == true ? 'row mb-5' : 'row mt-5 mb-5'">

      <div :class="widthValid == true ? 'col-12' : 'col-12 mt-4'">
        <h1 class="title text-uppercase font-weight-bold tamanhoFonte">
          CADASTRO DE NOVO GERENTE DE CONTA
        </h1>
      </div>

      <hr class="linha-amarela" />

      <div :class="widthValid == true ? 'col-12' : 'col-12 mt-4'">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
            <label>Nome:</label>
            <input type="text" class="form-control" v-model="dados.nome" placeholder="Informe o nome">
          </div>

          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
            <label>Sobrenome:</label>
            <input type="text" class="form-control" v-model="dados.sobrenome" placeholder="Informe o sobrenome">
          </div>

          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
            <label>CPF / CNPJ:</label>
            <input 
              type="text" 
              class="form-control" 
              v-model="dados.cpf_cnpj" 
              @blur="validarDocumento()" 
              placeholder="###.###.###-## OU ##.###.###/####-##" 
              v-mask="['###.###.###-##', '##.###.###/####-##']"
            > 
          </div>

          <div class="col-6 mt-2" v-if="empresa == true">
            <label>Nome fantasia:</label>
            <input type="text" class="form-control" v-model="dados.nome_fantasia" placeholder="Informe o nome fantasia">
          </div>

          <div class="col-6 mt-2" v-if="empresa == true">
            <label>Razão social:</label>
            <input type="text" class="form-control" v-model="dados.razao_social" placeholder="Informe a razão social">
          </div>

          <div class="col-6 mt-2">
            <label>Telefone:</label>
            <input type="text" class="form-control" v-model="dados.telefone" placeholder="(##) ####-####" v-mask="['(##) ####-####', '(##) # ####-####']">
          </div>

          <div class="col-6 mt-2">
            <label>WhatsApp:</label>
            <input type="text" class="form-control" v-model="dados.whatsapp" placeholder="(##) # ####-####" v-mask="['(##) ####-####', '(##) # ####-####']">
          </div>

          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
            <label>E-mail:</label>
            <input type="text" class="form-control" @blur="buscarEmail()" v-model="dados.email" placeholder="Informe o E-mail">
          </div>

          <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 mt-2">
            <label>Senha:</label>
            <input type="password" class="form-control" v-model="dados.password" placeholder="########">
          </div>

          <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 mt-2">
            <label>Repita a senha:</label>
            <input type="password" class="form-control" v-model="dados.confirm_senha" placeholder="########">
          </div>

          <div class="col-12 mt-4 text-center">
            <button class="btn btn-success" @click="saveGerente()">
              <i class="fas fa-save mr-2"></i>Criar conta
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import makeToast from '../mixins/makeToast';
import login from '@/mixins/login';

export default {
  name: 'ARCadastroGerente',
  mixins: [makeToast, login],

  data() {
    return {
      empresa: false,
      widthValid: false,
      dados: {
        nome: null,
        sobrenome: null,
        email: null,
        cpf_cnpj: null,
        nome_fantasia: null,
        razao_social: null,
        telefone: null,
        whatsapp: null,
        id: null,
        nota: '2',
        link_apk: '',
        lojista_id: null,
        lojista_nome: null,
        lojista_cnpj: null,
        password: '',
        confirm_senha: '',
        startDate: '',
        endDate: ''
      },
      data: []
    }
  },

  watch: {
    'dados.cpf_cnpj': function() {
      this.empresa = false;
      if(this.dados.cpf_cnpj && this.dados.cpf_cnpj.length && this.dados.cpf_cnpj.length > 14) {
        this.empresa = true;
      }
    }
  },

  created() {
    var larguraTela = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    
    if(larguraTela < 500) {
      this.widthValid = true;
    }
  },

  methods: {
    validarDocumento() {
      if(this.empresa == true && this.dados.cpf_cnpj != '' && this.dados.cpf_cnpj != null) {
        this.buscarCnpj();
      } else if(this.empresa == false && this.dados.cpf_cnpj != '' && this.dados.cpf_cnpj != null) {
        this.buscarCpf();
      }
    },
    buscarCnpj() {
      const cnpj = this.dados.cpf_cnpj.replace(/[^0-9]/g, '');

      this.$store.dispatch('startLoader');
      this.$store.dispatch('user/validarCnpj', cnpj)
        .then(async (response) => {
          if(response.data.valid == true) {
            this.dados.cpf_cnpj = '';
            this.makeToast('Oopss!', 'Esse CNPJ já está sendo utilizado, informe outro!', 'danger');
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },    
    buscarCpf() {
      const cpf = this.dados.cpf_cnpj.replace(/[^0-9]/g, '');

      this.$store.dispatch('startLoader');
      this.$store.dispatch('user/validarCpf', cpf)
        .then(async (response) => {
          if(response.data.valid == true) {
            this.dados.cpf_cnpj = '';
            this.makeToast('Oopss!', 'Esse CPF já está sendo utilizado, informe outro!', 'danger');
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    buscarEmail() {
      const data = {
        email: this.dados.email
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('user/validarEmail', data)
        .then(async (response) => {
          if(response.data.valid == true) {
            this.dados.email = '';
            this.makeToast('Oopss!', 'Esse E-Mail já está sendo utilizado, informe outro!', 'danger');
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    saveGerente() {
      const error = this.validForm();
      if(error == false) {
        this.$store.dispatch('startLoader');
        this.$store.dispatch('addGerenteContaUser', this.dados)
          .then((response) => {
            console.log(response)
            if(response.data.error == false) {
              this.$bvModal.hide('addGerente');
              this.makeToast('Sucesso', response.data.message, 'success');

              this.delayedLogin();
            } else {
              this.makeToast('Oopss', response.data.message, 'danger');
            }
          })
          .catch(() => {
            this.makeToast('Oopss', 'Erro ao salvar gerente!', 'danger');
          })
          .finally(() => {
            this.$store.dispatch('endLoader');
          })
      }
    },
    delayedLogin() {
      setTimeout(() => {
        this.login(this.dados.email, this.dados.password);
      }, 1000);
    }, 
    validForm() {
      var error = false;
      
      if(this.dados.nome == null || this.dados.nome == '') {
        this.makeToast('Oopss', 'Informe o nome!', 'danger');
        error = true;
      }

      if(this.dados.sobrenome == null || this.dados.sobrenome == '') {
        this.makeToast('Oopss', 'Informe o sobrenome!', 'danger');
        error = true;
      }

      if(this.dados.email == null || this.dados.email == '') {
        this.makeToast('Oopss', 'Informe o e-mail!', 'danger');
        error = true;
      }

      if(this.dados.cpf_cnpj == null || this.dados.cpf_cnpj == '') {
        this.makeToast('Oopss', 'Informe o CPF/CNPJ!', 'danger');
        error = true;
      }

      if((this.empresa == true) && (this.dados.nome_fantasia == null || this.dados.nome_fantasia == '')) {
        this.makeToast('Oopss', 'Informe o nome fantasia!', 'danger');
        error = true;
      }

      if((this.empresa == true) && (this.dados.razao_social == null || this.dados.razao_social == '')) {
        this.makeToast('Oopss', 'Informe a razão social!', 'danger');
        error = true;
      }

      if((this.dados.telefone == '' || this.dados.telefone == null) && (this.dados.whatsapp == null || this.dados.whatsapp == '')) {
        this.makeToast('Oopss', 'Informe o telefone ou whatsapp!', 'danger');
        error = true;
      }

      if (!this.$validate.password(this.dados.password)) {
        this.makeToast('Oopss', 'A senha precisa ter no mínimo 5 Caracteres!', 'danger');
        error = false;
      }

      if (this.dados.confirm_senha !== this.dados.password) {
        this.makeToast('Oopss', 'As senhas devem ser iguais!', 'danger');
        error = false;
      }

      return error;
    }
  },
};
</script>

<style scoped>
@media only screen and (max-width: 500px) {
  .tamanhoFonte{
    font-size: 20px;
  }
}
</style>